module.exports = __webpack_public_path__ + "static/media/10.6d2c2fee.svg";